import React, { useState } from 'react';
import { ButtonType, PickButton } from '../../../common/PickButton/PickButton';
import { getThemeLocal, setThemeLocal } from '../../../utils/localData';
import { themeList } from '../../../configs/themes';
import './themes.scss';

type Props = {
    themeClickEvent: (newTheme: string) => void
}

export const Themes = ({themeClickEvent}:Props) => {

    const [theme, setTheme] = useState(getThemeLocal() === null ? "light" : getThemeLocal());

    const toggleTheme = (newTheme: string) => {
        setThemeLocal(newTheme)
        setTheme(newTheme);
        themeClickEvent(newTheme);
    }

    const themeListDisplay = themeList.map((item, i) => {
        return (
            <PickButton 
                key={i + item.value} 
                clickEvent={() => toggleTheme(item.value)} 
                styling="theme-button" 
                type={(theme === item.value ? ButtonType.PRIMARY : ButtonType.SECONDARY)}
                content={
                    <div className='theme-button-context'>
                        {item.name}
                    </div>
                }
            />
        )
    });

    const themes = (
        <div className="profile-card base-background tiertary-color">
            <div className="card-section secondary-color">
                <div className="info-header-profile">
                    Themes
                </div>
                <div className="info-content">
                    <div className="info-field">
                        <div className="theme-content">
                            { themeListDisplay }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    return (
        <>
            {themes}
        </>
    );
}
